import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { PaisDocumento } from './paises-documento.model';

@Injectable({
  providedIn: 'root'
})
export class PaisDocumentoService {
  url: string;
  endpoint = 'paisesDocumento';

  constructor(private http: HttpClient) {}

  getPaisDocumento(): Observable<PaisDocumento[]> {
    return this.http.get<PaisDocumento[]>(`${this.url}/${this.endpoint}/`);
  }
}
